
export const es = {
  // Navigation
  "nav.home": "Inicio",
  "nav.listen": "Escuchar",
  "nav.about": "Nosotros",
  "nav.forArtists": "Para Artistas",
  "nav.brandsPartners": "Marcas/Socios",
  "nav.ranchfireLive": "RanchFire en Vivo!",
  "nav.media": "Medios",
  "nav.podcast": "Podcast",
  "nav.contact": "Contacto",
  "nav.listenNow": "Escuchar Ahora",
  "nav.followUs": "Síguenos",

  // Hero Section
  "hero.title": "Donde el Country Encuentra su Hogar",
  "hero.subtitle": "Transmitiendo las mejores melodías country, historias auténticas y la cultura del rancho las 24 horas del día, los 7 días de la semana",
  "hero.listenLive": "ESCUCHAR EN VIVO",
  "hero.exploreShows": "EXPLORAR PROGRAMAS",

  // About Section
  "about.title": "Nuestra Historia",
  "about.subtitle1": "Arraigado. Real. Country.",
  "about.p1": "En todo el suroeste, la música country viene en muchos estilos y sonidos diferentes. Vive cerca de la tierra y más cerca de la gente. Sonaba mientras se hacía el trabajo, las familias se reunían y los días largos se convertían en noches más largas. Era en inglés y en español. Se mezcló naturalmente con otros sonidos no porque alguien lo planeara, sino porque la vida lo exigía.",
  "about.p2": "Lo que algunos llaman el \"surgimiento\" de algo nuevo es realmente el regreso de algo familiar: Música country arraigada en lugares reales, llevada por personas que la viven todos los días.",
  "about.highlight1": "Este sonido no persigue tendencias.",
  "about.highlight2": "Se gana la lealtad.",
  "about.p3": "En RanchFire, tocamos Country de la manera en que siempre ha existido—sin filtros, vivido y construido para durar.",
  "about.tagline": "Arraigado. Real. Country.",

  // Programming Section
  "programming.title": "Listas de reproducción curadas, al estilo ranchfire",
  "programming.subtitle": "Colecciones seleccionadas para cada estado de ánimo y momento",
  "programming.playlist1.title": "Tex Mex Twang",
  "programming.playlist1.description": "🔥Tex Mex Twang mezcla country y Tex-Mex con carácter y corazón. Desde baladas atemporales hasta voces frescas, es el sonido de carreteras abiertas, noches de fogata e historias reales. Sube el volumen y deja que el fuego arda—esta es música que vive donde la tradición se encuentra con el presente.",
  "programming.playlist2.title": "The King's Highway- Tributo a George Strait",
  "programming.playlist2.description": "Ya sea que estés persiguiendo atardeceres en la I-10 o bailando bajo las estrellas de Hill Country, The King's Highway es tu banda sonora de lealtad, amor y orgullo de Lone Star—con los clásicos y el espíritu del sur de Texas que ha inspirado para mantener las botas marcando el ritmo y los corazones abiertos.",
  "programming.playlist3.title": "Regio Country",
  "programming.playlist3.description": "🔥 RanchFire Radio presenta \"Regio Country\": una playlist que une el espíritu del country americano con el orgullo regio. Guitarras, acordeones y voces que cuentan historias de frontera y raíces norteñas.",
  "programming.playlist4.title": "Tejano Ranch Country",
  "programming.playlist4.description": "Botas, metales y alma fronteriza. Tejano Ranch es donde el Country Texano se encuentra con el groove Tejano—riffs de acordeón, guitarras de acero y puro corazón. Desde carreteras honky-tonk hasta bailes de patio trasero, esta playlist cabalga al ritmo del orgullo del sur de Texas. Móntate y deja que el crossover suene.",
  "programming.playlist5.title": "Borderline Baladas",
  "programming.playlist5.description": "\"Borderline Baladas\" de RanchFire Radio es una peregrinación sonora a través del suroeste—donde el alma del desierto se encuentra con el country latino. Con Mike Aguilar y los Coupes' \"Mexican Hero\", esta playlist honra el carácter, el legado y el poder silencioso de las historias fronterizas.",
  "programming.playlist6.title": "Island Country Sunsets",
  "programming.playlist6.description": "La hora dorada se encuentra con la calma costera. Island Country Sunsets de RanchFire Radio mezcla alma country, calidez americana y grooves costeros Tex-Mex—una banda sonora perfecta para relajarse junto al agua, donde el día se desvanece y las historias comienzan.",

  // Listen Now Section
  "listenNow.title": "Escucha Ahora",
  "listenNow.subtitle": "Sintoniza nuestra transmisión en vivo y experimenta lo mejor del country",
  "listenNow.playButton": "REPRODUCIR EN VIVO",
  "listenNow.nowPlaying": "Reproduciendo Ahora",
  "listenNow.nowPlayingOn": "Reproduciendo en RanchFire",
  "listenNow.upNext": "Próximamente",
  "listenNow.liveNow": "En Vivo Ahora",
  "listenNow.listenLive": "Escuchar en Vivo",
  "listenNow.openPlayer": "Abrir Reproductor",
  "listenNow.playingInWindow": "Reproduciendo en ventana separada",
  "listenNow.streamInfo": "24/7 • Calidad HD • Sin Anuncios",
  "listenNow.alsoOn": "También en",
  "listenNow.recentlyPlayed": "Reproducido Recientemente",
  "listenNow.feature.live": "24/7 en Vivo",
  "listenNow.feature.liveDesc": "Música sin parar",
  "listenNow.feature.hd": "Calidad HD",
  "listenNow.feature.hdDesc": "Sonido cristalino",
  "listenNow.feature.adFree": "Sin Anuncios",
  "listenNow.feature.adFreeDesc": "Experiencia musical pura",
  "listenNow.popupBlocked": "Ventana Emergente Bloqueada",
  "listenNow.popupBlockedDesc": "Tu navegador bloqueó la ventana emergente del reproductor. Haz clic abajo para abrirlo en una nueva pestaña — ¡la música seguirá sonando mientras navegas!",
  "listenNow.cancel": "Cancelar",

  // Blog Section
  "blog.title": "Podcast \"Desde el Rancho\"",
  "blog.subtitle": "Historias, entrevistas y perspectivas desde el corazón de la música country",
  "blog.readMore": "Leer Más",
  "blog.viewAll": "Ver Todos los Episodios",
  "blog.latestPosts": "Últimas Publicaciones",

  // Community Section
  "community.title": "¡RanchFire en Vivo!",
  "community.subtitle": "Tu Resumen Quincenal de Country Texano",
  "community.description": "Eventos en vivo • Festivales • Escenas musicales • Marcas de estilo de vida • Impulso cultural",
  "community.joinTitle": "¡Únete a RanchFire en Vivo!",
  "community.deliveredBiweekly": "Entregado quincenalmente a tu bandeja de entrada",
  "community.feature.liveEvents": "Eventos en Vivo:",
  "community.feature.liveEventsDesc": "Conciertos y shows seleccionados en todo Texas",
  "community.feature.festivals": "Festivales:",
  "community.feature.festivalsDesc": "Programaciones, alertas de boletos y guías exclusivas",
  "community.feature.musicScenes": "Escenas Musicales:",
  "community.feature.musicScenesDesc": "Sonidos regionales y artistas emergentes",
  "community.feature.lifestyleBrands": "Marcas de Estilo de Vida:",
  "community.feature.lifestyleBrandsDesc": "Moda y cultura del Country Texano",
  "community.feature.culturalMomentum": "Impulso Cultural:",
  "community.feature.culturalMomentumDesc": "Lo que está moldeando el Red Dirt hoy",
  "community.successMessage": "¡Bienvenido a RanchFire en Vivo! Revisa tu bandeja de entrada.",
  "community.errorMessage": "Algo salió mal. Por favor intenta de nuevo.",
  "community.emailPlaceholder": "tu@correo.com",
  "community.subscribe": "Suscribirse",
  "community.subscribing": "Uniéndose...",
  "community.unsubscribeNote": "Cancela cuando quieras. Respetamos tu bandeja de entrada.",
  "community.learnMore": "Aprende más sobre RanchFire en Vivo!",

  // Contact Section
  "contact.title": "¿Eres una marca? ¡Hablemos!",
  "contact.subtitle": "¿Tienes una pregunta, solicitud de canción o quieres asociarte con nosotros? ¡Nos encantaría saber de ti!",
  "contact.letsConnect": "Conectemos",
  "contact.connectDescription": "Ya seas un artista buscando que tu música sea destacada, un patrocinador interesado en asociaciones, o un oyente con comentarios, queremos saber de ti.",
  "contact.location": "Ubicación",
  "contact.locationValue": "San Antonio, Texas, Estados Unidos",
  "contact.email": "Correo Electrónico",
  "contact.followUs": "Síguenos",
  "contact.yourName": "Tu Nombre",
  "contact.namePlaceholder": "Juan Pérez",
  "contact.emailAddress": "Correo Electrónico",
  "contact.emailPlaceholder": "juan@ejemplo.com",
  "contact.subject": "Asunto",
  "contact.selectSubject": "Selecciona un asunto",
  "contact.artistSubmission": "Envío de Artista",
  "contact.sponsorshipInquiry": "Consulta de Patrocinio",
  "contact.generalFeedback": "Comentarios Generales",
  "contact.technicalSupport": "Soporte Técnico",
  "contact.other": "Otro",
  "contact.message": "Mensaje",
  "contact.messagePlaceholder": "Cuéntanos lo que tienes en mente...",
  "contact.characters": "caracteres",
  "contact.sendMessage": "Enviar Mensaje",
  "contact.sending": "Enviando...",
  "contact.successTitle": "¡Mensaje enviado exitosamente!",
  "contact.successMessage": "Te responderemos pronto.",
  "contact.errorTitle": "Algo salió mal.",
  "contact.errorMessage": "Por favor intenta de nuevo.",

  // Schedule Section
  "schedule.title": "Horario Semanal",
  "schedule.subtitle": "Tu guía para la mejor programación de música country toda la semana",
  "schedule.monday": "Lunes",
  "schedule.tuesday": "Martes",
  "schedule.wednesday": "Miércoles",
  "schedule.thursday": "Jueves",
  "schedule.friday": "Viernes",
  "schedule.saturday": "Sábado",
  "schedule.sunday": "Domingo",
  "schedule.genreGuide": "Guía de Géneros",
  "schedule.listenNow": "Escuchar Ahora",
  "schedule.tuneInTo": "Sintoniza",
  "schedule.with": "con",
  "schedule.forTheBest": "para la mejor música",
  "schedule.music": "",
  "schedule.broadcastingLive": "Transmitiendo en vivo a las",
  "schedule.bringingYou": "trayéndote sonidos auténticos de Texas y momentos inolvidables.",

  // Media Section
  "media.title": "Medios",
  "media.subtitle": "Comunicados de Prensa y Noticias",
  "media.pressRelease": "Comunicado de Prensa",
  "media.headline": "RanchFire Radio se Lanza: Un Nuevo Hogar para la Música Country Auténtica",
  "media.subheadline": "RanchFireRadio.com trae Country Texano, Red Dirt y Country Tex-Mex a oyentes de todo el mundo",
  "media.downloadPressKit": "Descargar Kit de Prensa",
  "media.mediaInquiries": "Consultas de Medios",
  "media.pressKitTitle": "Kit de Prensa",
  "media.pressKitSubtitle": "Descarga recursos de marca y materiales de medios",
  "media.logos": "Logotipos",
  "media.brandAssets": "Recursos de Marca",
  "media.pressMaterials": "Materiales de Prensa",
  "media.mediaImages": "Imágenes de Medios",
  "media.forAdditionalAssets": "Para recursos adicionales, contacta",
  "media.close": "Cerrar",
  "media.mediaInquiryTitle": "Consulta de Medios",
  "media.mediaInquirySubtitle": "Ponte en contacto con nuestro equipo de prensa",
  "media.yourName": "Tu Nombre",
  "media.emailAddress": "Correo Electrónico",
  "media.mediaOutlet": "Medio / Publicación",
  "media.mediaOutletPlaceholder": "Texas Monthly, Rolling Stone, etc.",
  "media.yourMessage": "Tu Mensaje",
  "media.messagePlaceholder": "Cuéntanos sobre tu consulta, solicitud de entrevista o ángulo de historia...",
  "media.sendInquiry": "Enviar Consulta",
  "media.sending": "Enviando...",
  "media.inquirySent": "¡Consulta Enviada!",
  "media.inquiryResponse": "Te responderemos en 24-48 horas.",
  "media.mediaContact": "Contacto de Medios:",
  "media.tagline": "Arraigado. Real. Country.",

  // Featured Editorial Section
  "featuredEditorial.title": "El Sonido Que Nunca Se Fue",
  "featuredEditorial.p1": "Lo que algunos llaman el surgimiento de algo nuevo es realmente el regreso de algo familiar. Música country arraigada en lugares reales, llevada por personas que la viven todos los días. Este sonido no persigue tendencias. Se gana la lealtad.",
  "featuredEditorial.p2": "En RanchFire, no programamos momentos—construimos hábitos. Música para el viaje largo. Canciones que aguantan en repetición. Historias que no necesitan explicación.",
  "featuredEditorial.readStory": "Leer la historia →",

  // Footer
  "footer.copyright": "2026 © RanchFire Radio una división de RanchFire Multimedia, LLC",
  "footer.tagline": "Arraigado. Real. Country.",
  "footer.quickLinks": "Enlaces Rápidos",
  "footer.connect": "Conectar",
  "footer.newsletter": "Boletín",
  "footer.newsletterText": "Suscríbete para recibir actualizaciones y contenido exclusivo",
  "footer.subscribe": "SUSCRIBIRSE",
  "footer.emailPlaceholder": "Tu correo electrónico",
  "footer.rights": "Todos los derechos reservados.",
  "footer.poweredBy": "Desarrollado por Readdy",

  // Common Actions
  "actions.learnMore": "SABER MÁS",
  "actions.getStarted": "COMENZAR",
  "actions.contactUs": "CONTÁCTANOS",
  "actions.viewMore": "VER MÁS",
  "actions.playNow": "REPRODUCIR AHORA",
  "actions.subscribe": "SUSCRIBIRSE",
  "actions.submit": "ENVIAR",

  // Listen Live Strip
  "listenLiveStrip.nowPlaying": "Reproduciendo Ahora",
  "listenLiveStrip.listen": "ESCUCHAR",

  // Artist Spotlight
  "artistSpotlight.title": "Destacado del Artista",
  "artistSpotlight.subtitle": "Descubre Talento Country Increíble",
  "artistSpotlight.featured": "Artista Destacado",
  "artistSpotlight.bio": "Biografía",
  "artistSpotlight.listen": "ESCUCHAR",

  // Orientation
  "orientation.quote": "La música country no llegó aquí—siempre ha estado aquí. En todo el suroeste, ha vivido cerca de la tierra y más cerca de la gente. RanchFire toca Country de la manera en que siempre ha existido: sin filtros, vivido y construido para durar",

  // Language
  "lang.en": "EN",
  "lang.es": "ES",
  "lang.english": "English",
  "lang.spanish": "Español"
};

export default es;
